// const requireComponent = require.context(
//   '.', false, /base-[\w-]+\.vue$/ // load những file bắt đầu = base- và kết thúc là .vue
// );

// requireComponent.keys().forEach(fileName => {
//   const componentConfig = requireComponent(fileName);

//   // lấy pascal name của component
//   const componentName = upperFirst(
//     camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
//   )

//   Vue.component(componentName, componentConfig.default || componentConfig)
// });

export default {
  install(Vue) {
    const baseComponents = require.context(
      "@/components/BaseComponents",
      false,
      /\.vue$/
    );
    baseComponents.keys().forEach(fileName => {
      const componentConfig = baseComponents(fileName);
      if (componentConfig.default.name) {
        Vue.component(
          componentConfig.default.name,
          componentConfig.default || componentConfig
        );
      }
    });

    const softComponents = require.context(
      "@/components/SoftComponents",
      false,
      /\.vue$/
    );
    softComponents.keys().forEach(fileName => {
      const componentConfig = softComponents(fileName);
      if (componentConfig.default.name) {
        Vue.component(
          componentConfig.default.name,
          componentConfig.default || componentConfig
        );
      }
    });

    const buttonComponents = require.context(
      "@/components/ButtonComponents",
      false,
      /\.vue$/
    );
    buttonComponents.keys().forEach(fileName => {
      const componentConfig = buttonComponents(fileName);
      if (componentConfig.default.name) {
        Vue.component(
          componentConfig.default.name,
          componentConfig.default || componentConfig
        );
      }
    });
  }
};
